export const getLeaseDealScore = ({ lifetimeCost, msrp, term }) => (1200 * lifetimeCost) / (msrp * term);
